<template>
  <div
    class="product-gallery-3d"
  >
    <div
      class="product-gallery-3d__wrapper"
      v-html="current3dModelMarkup"
    />
  </div>
</template>

<script>

/**
 * -----------------------------------------------------------------------------
 * A native Shopify model viewer component for the current variants 3D model.
 * @param {String | Boolean} current3dModelMarkup - HTML markup of the model viewer generated by Shopify.
 *
 */

export default {
  name: 'ProductGallery3D',
  props: {
    current3dModelMarkup: {
      type: [Boolean, String],
      default: false,
    },
  },
  emits: ['gallery-closed'],

  watch: {

    /**
     * Watch the active state of the modal.
     */
    modalActive() {
      if (this.modalActive) {
        return
      }

      this.$emit('gallery-closed')
    },
  },
}
</script>

<style lang="scss">
@import './product-gallery-3d';
</style>
